// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","logo":"App_logo__7Edbg","logo-spin":"App_logo-spin__62DwI","header":"App_header__fhC8n","link":"App_link__kpF6Q"};